export default {
    AUTH: {
        CONFIRM: '/confirm',
        LOGIN: '/login',
        LOGOUT: '/logout',
        SANCTUM_CSRF: '/sanctum/csrf-cookie'
    },
    ME: '/api/me',
    ACTION: {
        DESTROY: '/api/actions/:id',
        INDEX: '/api/actions',
        STORE: '/api/actions',
        UPDATE: '/api/actions/:id',
        UPLOAD_ICON: '/api/actions/:id/icon'
    },
    ACTUALITY: {
        COMMENT: {
            DESTROY: '/api/actualities/:id/comments/:comment_id',
            STORE: '/api/actualities/:id/comments'
        },
        DESTROY: '/api/actualities/:id',
        INDEX: '/api/actualities?page=:page',
        LIKE: '/api/actualities/:id/like',
        SHOW: '/api/actualities/:id',
        STORE: '/api/actualities',
        UPDATE: '/api/actualities/:id',
        UPLOAD_IMAGES: '/api/actualities/:id/images'
    },
    ALERT: {
        INDEX: '/api/alerts',
        UPDATE: '/api/alerts/:id'
    },
    CATEGORY: {
        DESTROY: '/api/categories/:id',
        INDEX: '/api/categories',
        STORE: '/api/categories',
        UPDATE: '/api/categories/:id',
        UPLOAD_ICON: '/api/categories/:id/icon'
    },
    DATA: '/api/data',
    DELETENOTIFICATION: {
        DESTROY: '/api/notifications/:id',
        INDEX: '/api/notifications/mine',
        STORE: '/api/notifications',
        UPDATE: '/api/notifications/:id'
    },
    DOCUMENT: {
        DESTROY: '/api/documents/:id',
        INDEX: '/api/documents',
        STORE: '/api/documents',
        UPDATE: '/api/documents/:id',
        UPLOAD_FILE: '/api/documents/:id/file'
    },
    EMPLOYEE: {
        DESTROY: '/api/employees/:id',
        INDEX: '/api/employees',
        STORE: '/api/employees',
        UPDATE: '/api/employees/:id'
    },
    EVENT: {
        DESTROY: '/api/events/:id',
        INDEX: '/api/events',
        STORE: '/api/events',
        UPDATE: '/api/events/:id',
        UPLOAD_IMAGE: '/api/events/:id/image'
    },
    NOTICE: {
        COMMENT: {
            DESTROY: '/api/notices/:id/comments/:comment_id',
            STORE: '/api/notices/:id/comments'
        },
        DESTROY: '/api/notices/:id',
        INDEX: '/api/notices?page=:page',
        LIKE: '/api/notices/:id/like',
        MARKSEEN: '/api/notices/mark-seen',
        MINE: '/api/notices/mine',
        SHOW: '/api/notices/:id',
        STORE: '/api/notices',
        UNSEEN: '/api/notices/unseen',
        UPDATE: '/api/notices/:id',
        UPLOAD_IMAGES: '/api/notices/:id/images'
    },
    USER: {
        INDEX: '/api/users'
    },
}